import { render, staticRenderFns } from "./ikidsmodalgraduate.vue?vue&type=template&id=01bf3cdb&"
import script from "./ikidsmodalgraduate.vue?vue&type=script&lang=js&"
export * from "./ikidsmodalgraduate.vue?vue&type=script&lang=js&"
import style0 from "./ikidsmodalgraduate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports